import Home from "./pages/Home/Home.jsx";

let routes = [{ path: `/`, element: <Home /> }];

export default routes;
